var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResyncIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#003E88"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3267 15.3327H24.1921C23.6715 11.2973 20.229 8 16.0095 8C13.8881 8 11.9531 8.89051 10.5622 10.2544C10.0337 10.7117 10.0182 11.3695 10.3368 11.7947C10.6787 12.244 11.2926 12.3804 11.9221 11.8749C12.9789 10.84 14.4242 10.1822 16.0095 10.1822C19.0945 10.1822 21.5501 12.4766 22.0474 15.3327H20.8196C20.1513 15.3327 19.9493 15.9184 20.3689 16.512L22.4593 19.4884C22.8012 19.9698 23.3451 19.9618 23.687 19.4884L25.7774 16.5201C26.197 15.9184 26.0105 15.3327 25.3267 15.3327ZM6.67676 17.6673H7.82684C8.35526 21.7027 11.7899 25 16.0095 25C18.1387 25 20.0736 24.1095 21.4646 22.7537C21.993 22.2883 22.0085 21.6225 21.6899 21.2053C21.348 20.756 20.7341 20.6196 20.1047 21.1251C19.0556 22.168 17.6025 22.8178 16.0095 22.8178C12.9245 22.8178 10.4767 20.5314 9.97158 17.6673H11.1838C11.8521 17.6673 12.0542 17.0897 11.6268 16.488L9.54419 13.5116C9.20227 13.0302 8.65832 13.0382 8.3164 13.5116L6.22606 16.488C5.79866 17.0816 5.99293 17.6673 6.67676 17.6673Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResyncIcon);
export default __webpack_public_path__ + "static/media/resync-icon.af0552a8b031c2c97151a3c6f53acd0f.svg";
export { ForwardRef as ReactComponent };